export type StartBusiness = {
  formId: string;

  statistics: Array<{
    value: string;
    label: string;
  }>;
};

export const Businesstatistics: StartBusiness = {
  formId: 'start-project-form',
  statistics: [
    {
      value: '16',
      label: 'Years on the market',
    },
    {
      value: '200+',
      label: 'Happy clients',
    },
    {
      value: '60+',
      label: 'Business experts',
    },
    {
      value: '32M+',
      label: 'Lines of code',
    },
  ],
};
